<header class="modern-page-header"
        [class.clickable]="clickable"
        [class.selected]="selected"
        [class.mobile-menu-open]="mobileMenuOpen"
        [class.is-tablet]="deviceType === 'tablet'"
        [class.is-mobile]="deviceType === 'mobile'"
        [style.display]="visible ? 'flex' : 'none'"
        [style.background-color]="backgroundColor || null"
        (click)="onHeaderClick()">
  <!-- Logo -->
  <a class="header-logo" [href]="logo?.link || '/'">
    <img *ngIf="logo?.image" [src]="logo!.image" [alt]="logo!.alt || 'Logo'" />
    <span class="logo-text" 
          *ngIf="!logo?.image && logo?.text"
          [style.color]="getHeadingColor()"
          [style.font-family]="getHeadingFont()">{{ logo!.text }}</span>
    <span class="logo-text" 
          *ngIf="!logo?.image && !logo?.text"
          [style.color]="getHeadingColor()"
          [style.font-family]="getHeadingFont()">way</span>
  </a>

  <!-- Navigation (desktop) -->
  <nav class="header-nav" *ngIf="getNavigationItems().length > 0">
    <a *ngFor="let item of getNavigationItems(); trackBy: trackByIndex"
       class="nav-link"
       [class.active]="item.active"
       href="#"
       [style.color]="getHeadingColor()"
       [style.font-family]="getHeadingFont()"
       (click)="onNavigationItemClick(item, $event)">
      {{ item.label }}
    </a>
  </nav>

  <!-- CTA Button -->
  <div class="header-cta" *ngIf="ctaButton">
    <a class="cta-button"
       [href]="ctaButton.link"
       [style.background]="ctaButton.backgroundColor || '#1B5BFF'"
       [style.color]="ctaButton.textColor || '#FFFFFF'"
       [style.--cta-bg]="ctaButton.backgroundColor || '#1B5BFF'"
       (click)="onCTAButtonClick($event)">
      <span class="cta-button-text">{{ ctaButton.label || ctaButton.text || 'Book Now' }}</span>
      <span class="cta-button-arrow" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </a>
  </div>

  <!-- Hamburger Button (mobile only) -->
  <button class="hamburger-btn"
          *ngIf="getNavigationItems().length > 0 || ctaButton"
          [class.open]="mobileMenuOpen"
          (click)="toggleMobileMenu($event)"
          aria-label="Toggle navigation">
    <span class="hamburger-bar"></span>
    <span class="hamburger-bar"></span>
    <span class="hamburger-bar"></span>
  </button>
</header>

<!-- Mobile Nav Overlay -->
<div class="mobile-nav-overlay"
     *ngIf="mobileMenuOpen"
     (click)="closeMobileMenu()">
</div>

<!-- Mobile Nav Drawer (always rendered for CSS transitions) -->
<nav class="mobile-nav-drawer"
     [class.open]="mobileMenuOpen"
     [hidden]="!mobileMenuOpen && getNavigationItems().length === 0 && !ctaButton"
     *ngIf="getNavigationItems().length > 0 || ctaButton">
  <div class="mobile-nav-top">
    <div class="mobile-nav-header">
      <a class="mobile-nav-logo" [href]="logo?.link || '/'">
        <img *ngIf="logo?.image" [src]="logo!.image" [alt]="logo!.alt || 'Logo'" />
        <span *ngIf="!logo?.image && logo?.text" [style.color]="getHeadingColor()" [style.font-family]="getHeadingFont()">{{ logo!.text }}</span>
        <span *ngIf="!logo?.image && !logo?.text" [style.color]="getHeadingColor()" [style.font-family]="getHeadingFont()">way</span>
      </a>
    </div>

    <div class="mobile-nav-links">
      <a *ngFor="let item of getNavigationItems(); trackBy: trackByIndex"
         class="mobile-nav-link"
         [class.active]="item.active"
         href="#"
         [style.color]="getHeadingColor()"
         [style.font-family]="getHeadingFont()"
         (click)="onNavigationItemClick(item, $event); closeMobileMenu()">
        {{ item.label }}
      </a>
    </div>
  </div>

  <div *ngIf="ctaButton" class="mobile-nav-footer">
    <a class="mobile-cta-button"
       [href]="ctaButton.link"
       [style.background]="ctaButton.backgroundColor || '#1B5BFF'"
       [style.color]="ctaButton.textColor || '#FFFFFF'"
       [style.--cta-bg]="ctaButton.backgroundColor || '#1B5BFF'"
       (click)="onCTAButtonClick($event)">
      <span class="mobile-cta-text">{{ ctaButton.label || ctaButton.text || 'Book Wash' }}</span>
      <span class="mobile-cta-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </a>
  </div>
</nav>
